export default __webpack_public_path__ + "static/media/band11.03a9d002.jfif";